import { useMemo } from 'react';
import { Widget, WIDGET_TYPES } from '../widgets/constants';

const useWidgetsToRender = (summaryWidgets: Widget[], metricToNA: string[]) => {
  const widgetMap = useMemo(() => {
    const currentWidgetMap = {};

    summaryWidgets.map(({ widgetKey, enabled, config }) => {
      if (enabled) {
        if (widgetKey === WIDGET_TYPES.audienceMetrics.name) {
          currentWidgetMap[widgetKey] = config.metrics.filter(
            (metric) => !metricToNA.includes(metric)
          );
        } else if (
          !config.metrics.some((metric) => metricToNA.includes(metric))
        ) {
          currentWidgetMap[widgetKey] = config.metrics;
        }
      }
    });

    return currentWidgetMap;
  }, [summaryWidgets, metricToNA]);

  return { widgetMap };
};

export default useWidgetsToRender;
